var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.139,4.372L3.647,11.824c-0.089,0.04-0.146,0.126-0.147,0.222c-0.001,0.095,0.054,0.183,0.142,0.225l4.667,2.228 c0.086,0.041,0.188,0.032,0.264-0.024l4.538-3.298l-3.563,3.563C9.498,14.79,9.473,14.86,9.478,14.93l0.355,4.492 c0.008,0.099,0.077,0.185,0.174,0.216c0.026,0.009,0.053,0.012,0.079,0.012c0.073,0,0.143-0.03,0.192-0.086l2.477-2.791l3.062,1.423 c0.066,0.031,0.143,0.032,0.211,0.004c0.067-0.029,0.119-0.084,0.141-0.152l4.319-13.376c0.03-0.094,0.001-0.196-0.075-0.26 S20.23,4.332,20.139,4.372L20.139,4.372z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.24a8d6d9.svg";
export { ForwardRef as ReactComponent };